/*
 * @Desc: 约看 接口的统一出口
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2023-03-01 17:16:11
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const livesorder = {
  // 列表
  list (params) {
    return axios.get(api + 'lives/orderlist', { params: params })
  },
  // 详情
  detail (params) {
    return axios.get(api + 'lives/orderdetail', { params: params })
  },
  // 核销
  hexiao (params) {
    return axios.get(api + 'lives/orderhexiao', { params: params })
  },
  // 取消
  cancel (params) {
    return axios.post(api + 'lives/ordercancel', qs.stringify(params))
  },
  verify (params) {
    return axios.get(api + 'lives/orderverify', { params: params })
  },
  // 导出
  export (params) {
    return axios.post(api + 'lives/orderexport', qs.stringify(params))
  }
}

// 导出接口
export default livesorder
